export const initialState = {
    id: '',
    name: '',
    description: '',
    image: null,
    type: '0',
};

export const serviceCategoriesPath = '/service-categories';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Service Categories', path: serviceCategoriesPath },
    { label: 'Add Service Category', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Service Categories', path: serviceCategoriesPath },
    { label: 'Edit Service Category', path: '' },
];

export const addHeader = 'Service Category Details';
export const editHeader = 'Edit Service Category Details';

export const typeOptions = [
    { id: '0', name: 'Standard' },
    { id: '1', name: 'Location' },
];
